import { RawJobHistory } from "./api/commonAction";

export class Utilities {

  public static nameof = <T>(name: keyof T) => name;

  public static getReadableFileSizeString(file: File| null) {
    if (file === null) {
      return '0 KB';
    }
    let fileSizeInBytes = file.size;
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

public static checkFileSizeLimit(file: File| null, fileSizeLimit: string) {

  if (file === null) {
    return false;
  }

  let fileSizeLimitInBytes=parseInt(fileSizeLimit.replace("MB", "")) * 1024 * 1024;
  
  let fileSizeInBytes = file.size;

  return fileSizeInBytes > fileSizeLimitInBytes;
};

  public static getFileSizeInKB(sizeKBytes: number) {
    const jobSizeKBytes = (sizeKBytes / 1024);
    return Math.max(jobSizeKBytes, 0.1);
  }

public static getBaseFileName(name: string) {
  // chrome includes filenames like: 'C:\fakepath\filename' - even on macos!
  let pos = name.lastIndexOf('\\');
  if (pos === -1) {
    pos = name.lastIndexOf('/');
  }
  pos++;
  return name.substring(pos);
}

public static async readFile(f: File, callback: (text: string) => void) {
  let fr = new FileReader();
  let fileText = '';
  fr.readAsText(f);
  fr.addEventListener('load', () => {
      let fileContents = fr.result;
      if (typeof fileContents === 'string') {
          callback(fileContents);
      }
  });
  return fileText;
}

public static convertDescriptorToFilename(rawText: string) {
  let text = rawText.trim();
  let prevChar: string | null = null;
  let buffer = '';
  for (let index = 0; index < text.length; index++) {
      const char = text.charAt(index);
      if (index === 0) {
          buffer += char.toLocaleLowerCase();
      } else if (char === ' ') {
          // do nothing
      } else if (prevChar === ' ') {
          buffer += char.toLocaleUpperCase();
      }  else {
          buffer += char;
      }
      prevChar = char;           
  }
  return buffer;
}

public static compareRawJob(a: RawJobHistory, b: RawJobHistory) {
  if (a.timeCreate && b.timeCreate) {
    const parsedDateA = Date.parse(a.timeCreate);
    const parsedDateB = Date.parse(b.timeCreate);

    if (parsedDateA > parsedDateB) {
      return -1;
    }
    if (parsedDateA < parsedDateB) {
      return 1;
    }
    return 0;
  }
  return 0
}

public static invalidFileMessage = 'Valid JSON file expected';
public static fileSizeLimitMessage = 'Input file size limit reached.';
public static invalidChangesetMessage = 'Comparison result expected';
public static emptyFile = 'EMPTYFILE';
public static whitespacesInFilename = 'Whitespace in filename';
public static invalidFilename = 'Invalid filename';
public static duplicateFilename = 'Filename already used in this session'
public static invalidFilenameMessage = 'Valid file name expected';

}